<template>
    <div class="grid-inner">
        <div class="product-image">
            <a :href="product.url">
                <img :src="imageSmall(product.thumbnail)" :alt="product.name">
            </a>
            <a :href="product.url">
                <img :src="imageSmall(product.images.length >= 2 ? product.images[1] : product.thumbnail)" :alt="product.name">
            </a>
            <!-- <add-to-cart-component :data-product="product"></add-to-cart-component> -->
        </div>
        <div class="product-desc">
            <div class="product-title mb-0"><h4 class="mb-0"><a class="fw-medium" :href="product.url">{{ product.name }}</a></h4></div>
            <h5 class="product-price fw-normal">
                <span v-if="product.discount_price" class="text-decoration-line-through small nocolor">{{amountWithCurrency(product.public_price)}}</span>
                <span class="fw-bold nocolor">{{ amountWithCurrency(product.price) }}</span>
            </h5>
        </div>
    </div>
</template>
<script>
import store from '../CartStore'
export default {
    props: ['dataProduct'],
    store: store,
    data() {
        return {
            t: t,
            config: config,
            settings: settings,
            product: this.dataProduct,
            showPrice: config.modules.catalog_mode === false
        };
    },
};
</script>
